import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/web-development-2048x1575.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Webdevelopment() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Responsive Design",
            content: "We design websites that look stunning and work seamlessly on any device, from desktops to smartphones.",
        },
        {
            title: "User-Friendly Experience",
            content: "Our websites are intuitive and easy to navigate, ensuring visitors stay engaged and find what they need effortlessly.",
        },
        {
            title: "Optimized for Performance",
            content: "Speed and reliability are key to online success. We optimize every aspect of your website for quick load times and smooth functionality.",
        },
        {
            title: "Scalable Solutions",
            content: "As your business grows, so should your website. Our scalable designs allow you to add features and expand functionalities as needed.",
        },
        {
            title: "Enhanced Security",
            content: "With top-notch security protocols, we safeguard your website and customer data, providing peace of mind for you and your visitors.",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "E-commerce Platforms",
            desc: "Showcase your products and make online shopping seamless with our user-friendly, secure e-commerce solutions.",
        },
        {
            title: "Corporate Websites",
            desc: "Establish your brand’s digital presence with a professional website that highlights your company’s mission, values, and services.",
        },
        {
            title: "Custom Web Applications",
            desc: "Tailor-made web apps designed to streamline your business operations and drive efficiency.",
        },
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

      useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>Web Development</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/webdevelopment">Web Development</a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image"  data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content"data-aos="fade-right">
                            <h1>Web Development Service</h1>

                            <p>
                                Unlock the potential of your business with REDITE’s professional web development services.
                                Our team is dedicated to creating high-performance websites that captivate your audience
                                and drive meaningful engagement.
                            </p>

                            <h3>Custom-Built Websites for Every Business Need</h3>


                            <p>
                                At REDITE, we understand that a website is much more than an online presence—it’s a critical
                                component of your brand’s identity and growth. Our web development services cover everything
                                from visually appealing front-end designs to robust, secure back-end functionalities.
                                We customize each website to suit your unique business goals and industry requirements.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>KEY FEATURES OF OUR WEB DEVELOPMENT SERVICES</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>

                
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>WEB DEVELOPMENT SOLUTIONS WE OFFER</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Approach: Putting Your Vision First</h4>
                        <p>
                            Our web development process is collaborative and client-focused. From the
                            initial consultation to the final launch, we work closely with you to ensure
                            every detail aligns with your vision and objectives. We handle all aspects of
                            development, including design, coding, testing, and deployment, providing you
                            with a smooth and stress-free experience.
                        </p>

                        <h4>Why Choose REDITE for Web Development?</h4>
                        <p>
                            With years of experience and a passion for innovative digital solutions, REDITE
                            combines technical expertise with a keen understanding of modern business needs.
                            We are committed to helping you build an online platform that not only reflects
                            your brand but also drives engagement and growth.
                        </p>

                        <p>
                            Ready to elevate your online presence?
                            <span> Contact REDITE today and let us develop a website that sets your business apart.</span>
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Webdevelopment;
